module.exports = __webpack_public_path__ + "img/lens-150-minus-02.a9a54926.png";